export default __webpack_public_path__ + "static/media/thumb-GNSS-Antenna-4.432c88f7.png";